import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IProductAddToCartTemplateDialogService, IProductAddToCartTemplateDialogServiceToken } from 'projects/shared/lib/interfaces/services/dialogs/product-add-to-cart-template-dialog-service.abstract';
import { ICartService, ICartServiceToken } from 'projects/shared/lib/services/data/cart/cart-service.interface';
import { ProductIdentifierDto, QuantityUnitDto, ShoppingCartDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

@Component({
  selector: 'app-product-add-to-cart-template-icon',
  imports: [CommonModule],
  templateUrl: './product-add-to-cart-template-icon.component.html',
  styleUrls: ['./product-add-to-cart-template-icon.component.scss']
})
export class ProductAddToCartTemplateIconComponent {
  @Input() productIdentifier?: ProductIdentifierDto;
  @Input() quantityUnit?: QuantityUnitDto;
  @Input() addInfoBelow?: boolean | undefined;
  @Input() quantity: number | undefined;

  private readonly cartDataService: ICartService;
  private productAddToCartTemplateDialogService: IProductAddToCartTemplateDialogService;

  public constructor() {
    this.cartDataService = inject(ICartServiceToken);
    this.productAddToCartTemplateDialogService = inject(IProductAddToCartTemplateDialogServiceToken);
  }

  public addToCartTemplateClick() {
    this.productAddToCartTemplateDialogService.productAddToCartTemplateDialogShow(
      () => {
        // Cancel
      },
      (cartTemplate: ShoppingCartDto) => {
        // Yes
        if (this.productIdentifier == undefined) {
          return;
        }

        if (cartTemplate == undefined) {
          return;
        }

        if (this.quantity == undefined) {
          return;
        }

        this.cartDataService.cartItemSetByProductIdentifierAsync(
          cartTemplate,
          this.productIdentifier,
          this.quantity,
          this.quantityUnit,
          undefined
        );
      }
    );
  }
}
